import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2025 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Loader as RSLoader } from "rsuite";
function TolLoader(props) {
    const { size, content, vertical } = props;
    return (_jsx("div", { className: "tol-loader", children: _jsx(RSLoader
        // @ts-ignore
        , { 
            // @ts-ignore
            size: size, content: content, vertical: vertical }) }));
}
export default TolLoader;
